import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all plantStatuses
export const getPlantStatus = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/plant-status`);
    return response.data;
  } catch (error) {
    console.error("Error fetching plantStatuses:", error.response?.data || error);
    throw error;
  }
};

// GET a single plantStatus
export const getPlantStatusById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/plant-status/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching plantStatus:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new plantStatus
export const createPlantStatus = async (plantStatusData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/plant-status`, plantStatusData);
    return response.data;
  } catch (error) {
    console.error("Error creating plantStatus:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing plantStatus
export const updatePlantStatus = async (id, plantStatusData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/plant-status/${id}`, plantStatusData);
    return response.data;
  } catch (error) {
    console.error("Error updating plantStatus:", error.response?.data || error);
    throw error;
  }
};

// DELETE a plantStatus
export const deletePlantStatus = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/plant-status/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting plantStatus:", error.response?.data || error);
    throw error;
  }
};
